import { render, staticRenderFns } from "./TimetableView-FreePlaces.vue?vue&type=template&id=6bfef148"
import script from "./TimetableView-FreePlaces.vue?vue&type=script&lang=js"
export * from "./TimetableView-FreePlaces.vue?vue&type=script&lang=js"
import style0 from "./TimetableView-FreePlaces.vue?vue&type=style&index=0&id=6bfef148&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports